<div class="tw-font-lexend">
  <div
    class="tw-px-4 tw-py-[5.5px] tw-bg-gradient-address-prefill tw-cursor-pointer"
    role="button"
    tabindex="0"
    (click)="onBannerClick()"
  >
    <div class="tw-text-[14px] tw-mb-1">
      <!-- State 1: Before fetching addresses -->
      <p *ngIf="shiprocketAddressesCount === 0" i18n="@@needHelpFillingAddress">
        <span class="tw-font-[700]">Need help</span>
        <span class="tw-font-[400]"> in filling your address?</span>
      </p>

      <!-- State 2: After fetching addresses -->
      <p *ngIf="shiprocketAddressesCount === 1">
        <span class="tw-font-[400]" i18n="@@addressFound">{{ shiprocketAddressesCount }} Address Found</span>
      </p>
      <p *ngIf="shiprocketAddressesCount > 1">
        <span class="tw-font-[400]" i18n="@@addressesFound">{{ shiprocketAddressesCount }} Addresses Found</span>
      </p>
    </div>
    <div class="tw-flex tw-justify-between tw-items-center">
      <!--      button-->
      <div class="tw-flex-1">
        <!-- State 1: Find my address button -->
        <div
          *ngIf="shiprocketAddressesCount === 0"
          class="tw-font-[600] tw-bg-teal-600 tw-text-white tw-px-3 tw-py-[3px] tw-max-w-max tw-rounded-[6px]"
        >
          <span class="tw-whitespace-nowrap tw-text-200" i18n="@@findMyAddress">Find my address</span>
        </div>

        <!-- State 2: Select Address button -->
        <div
          *ngIf="shiprocketAddressesCount > 0"
          class="tw-font-[600] tw-bg-teal-600 tw-text-white tw-px-3 tw-py-[3px] tw-max-w-max tw-rounded-[6px]"
        >
          <span class="tw-whitespace-nowrap tw-text-200" i18n="@@selectShiprocketAddress">Select Address</span>
        </div>
      </div>
      <!--      shiprocket image-->
      <div class="tw-w-[133px]">
        <img src="/assets/icons/poweredByShipRocket.png" class="tw-mix-blend-multiply tw-ml-auto" alt="Powered By Shiprocket" />
      </div>
    </div>
  </div>
</div>
